import { createBrowserRouter, Navigate } from 'react-router-dom';
import { MainLayout } from './components/Layout/MainLayout';
import { Login } from './pages/Login';
import { Dashboard } from './pages/Dashboard';
import { OrderList } from './pages/OrderList';
import { OrderDetail } from './pages/OrderDetail';
import ConversationList from './pages/ConversationList';
import ConversationDetail from './pages/ConversationDetail';
import DLQViewer from './pages/DLQViewer';
import ClientDetail from './pages/ClientDetail';
import ClientList from './pages/ClientList';
import Analytics from './pages/Analytics';
import TelegramDialogs from './pages/TelegramDialogs';
import { useAuth } from './hooks/useAuth';

// Protected route wrapper
const ProtectedRoute = ({ children }: { children: React.ReactNode }) => {
  const { isAuthenticated } = useAuth();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
};

const SettingsPage = () => <div><h1>Налаштування</h1><p>В розробці...</p></div>;

export const router = createBrowserRouter([
  {
    path: '/login',
    element: <Login />
  },
  {
    path: '/',
    element: (
      <ProtectedRoute>
        <MainLayout />
      </ProtectedRoute>
    ),
    children: [
      {
        index: true,
        element: <Dashboard />
      },
      {
        path: 'orders',
        element: <OrderList />
      },
      {
        path: 'orders/:id',
        element: <OrderDetail />
      },
      {
        path: 'conversations',
        element: <ConversationList />
      },
      {
        path: 'conversations/:id',
        element: <ConversationDetail />
      },
      {
        path: 'dlq',
        element: <DLQViewer />
      },
      {
        path: 'clients',
        element: <ClientList />
      },
      {
        path: 'clients/:id',
        element: <ClientDetail />
      },
      {
        path: 'analytics',
        element: <Analytics />
      },
      {
        path: 'telegram',
        element: <TelegramDialogs />
      },
      {
        path: 'settings',
        element: <SettingsPage />
      }
    ]
  }
]);
